import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import PageTemplate from './Template'

const BodyControl = (props) => {
  return <PageTemplate props={props} layout="body" title="แสดงข้อมูล" />
}

export const bodyControlTester = rankWith(3, scopeEndsWith('body'))

export default withJsonFormsControlProps(BodyControl)
